export default __webpack_public_path__ + "static/media/NeueMachina-Bold.1bfa28d0.woff2";